export const priorityNames = ['Hot', 'Warm', 'Cold', 'Follow-up', 'Archived']

export const SALUTATIONS = [
  {
    value: 'MR',
    label: 'Mr.'
  },
  {
    value: 'MS',
    label: 'Ms.'
  }
]
